import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useGetGroupsQuery } from "../features/groups/groupsApiSlice"

function GroupFilter() {
    const {groupId, type} = useParams()
    const[group,setGroup] = useState(groupId)

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
    const navigate = useNavigate()
    if (!groups?.length) return <div>loading...</div>
      const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            >{group.name} [{group.year}] {group.companyname}</option >
        )
    })
    const changeGroupBtn=(e)=>{
        const val = e.target.value
        setGroup(val)
        if(val)
            navigate(`/${type}/${val}/`)
        else
         navigate(`/${type}/0/`)

    }
    const content =(<>
        <div className="dash-header-filter">
            <select
                id="group"
                name="group"
                className={`form__select`}
                value={group}
                onChange={changeGroupBtn}
            >
                <option value="">--בחר קבוצה--</option>
                {options}
            </select>
        </div>
    </> ) 
  return content
}

export default GroupFilter